import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';

import useShopRecommendedItems from './hooks/useShopRecommendedItems';
import RecommendationItem from './RecommendationItem';
import styles from './styles.module.scss';

interface Props {
    shopId: string;
    itemId: string;
}

function Recommendation({ shopId, itemId }:Props) {
  const { title, items } = useShopRecommendedItems(shopId, itemId);
  return (
        <Column className={styles.container}
                fullWidth
                as='section'>
            {(title) && (
                <div className={styles.title}>
                    <Text size='xl' fontWeight='bold'>
                        {title}
                    </Text>
                </div>
            )}
            <Row spacing={12}
                 as='article'
                 className={styles.contents}>
                {items?.map((item) => (
                    <RecommendationItem item={item}
                                        shopId={shopId}
                                        key={item.shopItemId} />
                ))}
            </Row>
        </Column>
  );
}

export default Recommendation;
